// LAS PORTADAS VIVEN AQUI, y antes se le pedian a `images.unsplash.com` en cada visita.
// Cinco de estas se ven en la pantalla de inicio, o sea sin tener cuenta: la IP de cada
// visitante llegaba a un servidor ajeno antes de que nadie consintiera nada. Van importadas
// y no como texto a proposito -un fichero que no existe revienta el build en vez de verse
// como un hueco gris-. La procedencia y la licencia, en `portadas/PROCEDENCIA.md`.
import portadaFilosofia from "@/portadas/filosofia.webp";
import portadaLiteratura from "@/portadas/literatura.webp";
import portadaPsicologia from "@/portadas/psicologia.webp";
import portadaCulturaClasica from "@/portadas/cultura-clasica.webp";
import portadaMusica from "@/portadas/musica.webp";

// LAS CINCO COMPETENCIAS ALPHA, y la constante se sigue llamando `COURSES` porque asi la
// nombra el glosario y la ruta es `/cursos`. Lo que NO son es «las 5 materias»: materias hay
// siete y estan declaradas en `PILLARS`, y cursos publicados hay trece. Aqui hay cinco
// competencias, cada una con su mentor y su constelacion.
//
// EL NOMBRE DEL MENTOR ESTA AQUI PORQUE SE PINTA AQUI, y es una copia: la lista de
// verdad es `backend/app/domain/mentores.py`, que ademas lleva su tono, su saludo y lo
// que nunca dice. La tarjeta de cada competencia ponia «Sócrates» para las cinco -el
// nombre viejo del mentor unico, de cuando solo habia uno-, asi que al pasar el cursor
// por Música salia el mentor de otra. Que sean dos listas lo vigila
// `tools/check_contratos.py`, que las compara por disciplina: el dia que una se mueva,
// se pone rojo.
// Cada curso lleva integrado a Sócrates (Mentor IA) con el subagente de la materia.
// `agentKey` es la clave que espera el backend en /api/mentor/chat.

export const COURSES = [
  {
    slug: "filosofia",
    name: "Filosofía",
    nombreCompetencia: "Pensamiento crítico",
    emoji: "🧠",
    competenciaDesc: "Aprende lógica, argumentación y filosofía para pensar mejor.",
    discipline: "Filosofía",
    mentor: "Hipatia",
    // LAS MATERIAS QUE DE VERDAD HAY PUBLICADAS bajo esta competencia, en el orden en
    // que se cursan. Es distinto de `discipline`, que es UNA -la de su mentor y la de
    // su constelación, y por eso aquella sigue en singular en «Tu mentor · Filosofía»-.
    // Esto es lo que ve quien abre el desplegable buscando si damos su asignatura.
    asignaturas: ["Ética", "Filosofía", "Historia de la Filosofía"],
    number: "01",
    agentKey: "filosofia",
    tagline: "De los presocráticos al pensamiento contemporáneo.",
    summary:
      "Un itinerario completo por la historia del pensar: metafísica, ética, estética y filosofía contemporánea, con Sócrates como interlocutor permanente.",
    accent: "Ética · Metafísica · Fenomenología",
    image: portadaFilosofia,
    intro:
      "Buenas. Dime en qué punto está hoy tu pensamiento filosófico. Puedo diseñarte un itinerario personalizado desde los presocráticos hasta la teoría contemporánea.",
    prompts: [
      "¿Qué diferencia hay entre saber y comprender?",
      "Explícame Kant como si nunca hubiese leído filosofía",
      "¿Por dónde empiezo con Nietzsche?",
    ],
  },
  {
    slug: "literatura",
    name: "Literatura",
    nombreCompetencia: "Comunicación",
    emoji: "💬",
    competenciaDesc: "Escritura, literatura, storytelling y oratoria.",
    discipline: "Literatura",
    mentor: "Max",
    asignaturas: ["Lengua castellana", "Literatura"],
    number: "02",
    agentKey: "literatura",
    tagline: "Obras, autores y estructuras que cambian el mundo.",
    summary:
      "Teoría, historia y crítica literaria: de Homero a la narrativa contemporánea, aprendiendo a leer con profundidad y a construir tu propia voz.",
    accent: "Narrativa · Voz · Forma",
    image: portadaLiteratura,
    intro:
      "Dime qué has leído y qué te ha inquietado. Puedo trazarte una ruta literaria desde Homero hasta lo contemporáneo.",
    prompts: [
      "Por qué es importante leer a Borges",
      "Qué es el flujo de conciencia en literatura",
      "Ruta para entender la novela latinoamericana",
    ],
  },
  {
    slug: "psicologia",
    name: "Psicología",
    nombreCompetencia: "Autocomprensión",
    emoji: "❤️",
    competenciaDesc: "Orientación, hábitos y neuropsicología para conocerte mejor.",
    discipline: "Psicología",
    mentor: "Ariadna",
    asignaturas: ["Psicología"],
    number: "03",
    agentKey: "psicologia",
    tagline: "Cómo funciona tu cabeza y qué hacer con ella.",
    summary:
      "De la memoria y los hábitos a la orientación: cómo aprende tu cabeza, cómo decide y cómo se entrena, sin simplificar al sujeto.",
    accent: "Memoria · Hábitos · Decisiones",
    image: portadaPsicologia,
    intro:
      "Dime qué se te resiste: estudiar, recordar, decidir, sostener un hábito. Empezamos por ahí.",
    prompts: [
      "¿Por qué se me olvida lo que estudio?",
      "¿Cómo se forma un hábito?",
      "¿Cómo elijo entre bachillerato y FP?",
    ],
  },
  {
    slug: "cultura-clasica",
    name: "Cultura Clásica",
    nombreCompetencia: "Cultura y política",
    emoji: "🌍",
    competenciaDesc: "Mitología, Grecia, Roma, historia de las ideas y política.",
    discipline: "Cultura Clásica",
    mentor: "Ulises",
    // Latín primero: es lo que hay escrito -tres cursos completos- y Cultura Clásica
    // viene detrás.
    asignaturas: ["Latín", "Cultura Clásica"],
    number: "04",
    agentKey: "cultura-clasica",
    tagline: "Grecia y Roma: las raíces de nuestro presente.",
    summary:
      "Mitología, historia, arte y lenguas clásicas. El mundo grecolatino como clave para leer la cultura contemporánea.",
    accent: "Mito · Polis · Legado",
    image: portadaCulturaClasica,
    intro:
      "Todo lo que piensas tiene una raíz antigua. Dime qué te intriga del mundo clásico y empezamos a excavar.",
    prompts: [
      "¿Qué nos enseña el mito de Prometeo?",
      "Diferencias entre la democracia ateniense y la actual",
      "¿Por qué seguimos leyendo a los estoicos?",
    ],
  },
  {
    slug: "musica",
    name: "Música",
    nombreCompetencia: "Creatividad",
    emoji: "🎨",
    competenciaDesc: "Música, creatividad e improvisación para crear con profundidad.",
    discipline: "Música",
    mentor: "Lira",
    asignaturas: ["Música"],
    number: "05",
    agentKey: "musica",
    tagline: "Estética, historia y análisis musical profundo.",
    summary:
      "Aprender a escuchar de otra manera: armonía, forma e historia de la música, de Bach al minimalismo y más allá.",
    accent: "Armonía · Forma · Estética",
    image: portadaMusica,
    intro:
      "¿Qué escuchas y qué te confunde de lo que escuchas? Puedo enseñarte a oír diferente.",
    prompts: [
      "Cómo escuchar a Bach analíticamente",
      "Qué distingue música tonal de atonal",
      "Ruta desde Beethoven hasta el minimalismo",
    ],
  },
];

export const getCourseBySlug = (slug) => COURSES.find((c) => c.slug === slug);

// ─────────────────────────────────────────────────────────────────────────────
// Capa de competencias (escaparate). Las 5 competencias son la puerta de entrada
// del alumno; cada una se apoya en una de las 5 disciplinas de arriba (la
// "constelación", que sigue siendo la identidad del mentor de Sócrates).
// El contenido, los slugs, los mentores y los mapas NO cambian: esto es solo la
// forma en que se presenta.
//
// EL ORDEN SALE DE LOS NÚMEROS, Y NO DE UNA LISTA A MANO. Era una lista escrita aparte y el 8
// de octubre de 2026 Gabri la cazó a ojo: *«al abrir los cursos, Cultura Clásica aparece como
// competencia 04 y Música como 05, pero en la sección de Competencias aparece primero Música»*.
// Dos sitios decían el orden —el `number` de cada ruta y esta lista— y decían cosas distintas.
// **Un número con dos oficios acaba contradiciéndose**, y no hay error que lo avise: se ve, y
// sólo si alguien se fija en los dos sitios a la vez.
//
// Y AHORA EL `number` ES EL ORDEN: cambiarlo mueve la tarjeta, y no hay nada que sincronizar.
export const COMPETENCIA_ORDER = [...COURSES]
  .sort((a, b) => String(a.number).localeCompare(String(b.number)))
  .map((c) => c.slug);

// Rutas en el horizonte — se muestran bloqueadas ("Próximamente") para transmitir visión.
//
// EMPRENDIMIENTO, LA SEXTA (18 oct 2026). Gabri: una competencia con empresa, economía, IA y
// marketing, cruzada con el currículo -«Economía y Emprendimiento» de 4.º de ESO, «Empresa y
// Diseño de Modelos de Negocio» de 2.º de Bachillerato- y con la competencia emprendedora, que
// es una de las ocho clave de la LOMLOE. Absorbe las dos tarjetas que había de IA y de Empresa.
// Antes de escribir una lección se MIDE EL INTERÉS: quien la pulsa -aquí o en la barra- suma
// uno en el recuento de pantallas, en `pantalla`, sin nadie dentro. Se mira en Analítica > Uso.
export const COMING_SOON = [
  {
    emoji: "🚀", name: "Emprendimiento",
    desc: "Empresa, economía, IA y marketing, con la cabeza de las humanidades.",
    asignaturas: ["Empresa", "Economía", "IA", "Marketing"],
    pantalla: "/proximamente/emprendimiento",
  },
  { emoji: "💻", name: "Tecnología", desc: "Fundamentos digitales y pensamiento computacional." },
];
